(function () {
  'use strict';

  if (window.__h25CustomerPrivacySyncLoaded) return;
  window.__h25CustomerPrivacySyncLoaded = true;

  var COOKIE_NAME = 'h25_consent_decision';
  var COOKIE_DAYS = 30;

  function readCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[1]) : null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function syncConsent(decision, persist) {
    if (!window.Shopify || !window.Shopify.customerPrivacy) {
      console.warn('[h25-consent-sync] Shopify.customerPrivacy not loaded; consent not synced');
      return;
    }
    var granted = decision === 'accept';
    var consent = {
      marketing: granted,
      analytics: granted,
      preferences: granted,
      sale_of_data: granted
    };
    try {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, function (result) {
        console.log('[h25-consent-sync] consent ' + decision + ' (persist=' + !!persist + '):', result);
      });
      if (persist) writeCookie(COOKIE_NAME, decision, COOKIE_DAYS);
    } catch (err) {
      console.error('[h25-consent-sync] setTrackingConsent error:', err);
    }
  }

  function applyInitialConsent() {
    var saved = readCookie(COOKIE_NAME);
    if (saved === 'accept' || saved === 'decline') {
      syncConsent(saved, false);
    } else {
      syncConsent('accept', false);
    }
  }

  if (window.Shopify && window.Shopify.customerPrivacy) {
    applyInitialConsent();
  } else {
    var retries = 0;
    var retryInterval = setInterval(function () {
      if (window.Shopify && window.Shopify.customerPrivacy) {
        clearInterval(retryInterval);
        applyInitialConsent();
      } else if (++retries > 20) {
        clearInterval(retryInterval);
        console.warn('[h25-consent-sync] Shopify.customerPrivacy never loaded after 10s');
      }
    }, 500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('cookie-banner button[name]');
    if (!btn) return;
    if (btn.name === 'accept') syncConsent('accept', true);
    else if (btn.name === 'decline') syncConsent('decline', true);
  }, false);
})();
